/* src/app/admin-dashboard/my-tasks/my-tasks.component.css */
.mt-page {
  max-width: 640px;
  margin: 24px auto;
  padding: 0 16px;
}
.mt-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
}
.mt-empty {
  text-align: center;
  color: #94a3b8;
  padding: 48px 0;
}
.mt-empty mat-icon {
  font-size: 40px;
  width: 40px;
  height: 40px;
  margin-bottom: 8px;
}
.mt-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  padding: 12px 16px;
  margin-bottom: 10px;
  border-left: 4px solid transparent;
}
.mt-card--today {
  border-left-color: #d97706;
}
.mt-card--overdue {
  border-left-color: #dc2626;
}
.mt-card-main {
  flex: 1 1 auto;
  cursor: pointer;
}
.mt-card-title {
  font-weight: 600;
  font-size: 15px;
  color: #0f172a;
}
.mt-card-sub {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}
.mt-badge {
  display: inline-block;
  margin-left: 8px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 999px;
  padding: 1px 8px;
}
.mt-badge--overdue {
  background: #fee2e2;
  color: #b91c1c;
}
.mt-badge--today {
  background: #fef3c7;
  color: #92400e;
}
/*# sourceMappingURL=my-tasks.component.css.map */
